export const messages = {
  en: {
    appName: "Home Lovin",
    appSubtitle: "Real Estate CRM",
    dashboard: "Dashboard",
    leads: "Leads",
    matching: "Matching",
    properties: "Properties",
    viewings: "Viewings",
    followups: "Follow-ups",
    pipeline: "Pipeline",
    commissions: "Commissions",
    configuration: "Configuration",
    masterData: "Master Data",
    admin: "Admin",
    signIn: "Sign in",
    signOut: "Sign out",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    addLead: "Add lead",
    addProperty: "Add property"
  },
  th: {
    appName: "Home Lovin",
    appSubtitle: "ระบบ CRM อสังหาริมทรัพย์",
    dashboard: "แดชบอร์ด",
    leads: "ลูกค้า",
    matching: "จับคู่ทรัพย์",
    properties: "ทรัพย์",
    viewings: "นัดชม",
    followups: "ติดตามงาน",
    pipeline: "ไปป์ไลน์",
    commissions: "ค่าคอมมิชชั่น",
    configuration: "ตั้งค่า",
    masterData: "ข้อมูลตั้งต้น",
    admin: "ผู้ดูแล",
    signIn: "เข้าสู่ระบบ",
    signOut: "ออกจากระบบ",
    save: "บันทึก",
    delete: "ลบ",
    edit: "แก้ไข",
    addLead: "เพิ่มลูกค้า",
    addProperty: "เพิ่มทรัพย์"
  }
};

export type Locale = keyof typeof messages;
